import { useApp } from "../app-context.js";

interface StatProps {
  label: string;
  type: "" | "positive" | "negative" | "moved";
  value: string;
}

function Stat({ label, type, value }: StatProps) {
  return (
    <div class={`stat ${type}`}>
      <strong>{value}</strong>
      <span>{label}</span>
    </div>
  );
}

export function Summary({ onReset }: { onReset(): void }) {
  const {
    analysis, hideUnchangedMoves, reviewed, reviewIds,
    setHideUnchangedMoves, setShowReviewed, showReviewed,
  } = useApp();
  const { moves, stats } = analysis;
  const reviewedCount = [...reviewIds].filter((id) => reviewed.has(id)).length;

  return (
    <>
      <div class="summary-bar">
        <div>
          <button class="back-button" id="back-button" type="button" onClick={onReset}>← New diff</button>
          <h2>Analysis</h2>
        </div>
        <div class="summary-actions">
          <button
            class={`move-collapse-toggle${hideUnchangedMoves ? " is-active" : ""}`}
            type="button"
            aria-pressed={hideUnchangedMoves}
            disabled={moves.length === 0}
            onClick={() => setHideUnchangedMoves((value) => !value)}
          >
            <span>Exact moved lines</span>
            <b>{hideUnchangedMoves ? "Show all" : "Hide unchanged"}</b>
          </button>
          <button
            class={`review-toggle${showReviewed ? " showing-reviewed" : ""}`}
            id="review-toggle"
            type="button"
            aria-pressed={showReviewed}
            disabled={reviewedCount === 0}
            onClick={() => setShowReviewed((value) => !value)}
          >
            <span id="review-progress">{reviewedCount} / {reviewIds.size} reviewed</span>
            <b id="review-toggle-label">{showReviewed ? "Hide reviewed" : "Show reviewed"}</b>
          </button>
          <div class="stats" id="stats">
            <Stat value={String(stats.filesChanged)} label={stats.filesChanged === 1 ? "file" : "files"} type="" />
            <Stat value={`+${stats.additions}`} label="added" type="positive" />
            <Stat value={`−${stats.deletions}`} label="removed" type="negative" />
            <Stat value={`${stats.movedLines}`} label="moved" type="moved" />
          </div>
        </div>
      </div>
      <div class="explanation" id="explanation">
        <span class={moves.length ? "pulse-dot" : "quiet-dot"} />
        {moves.length ? (
          <><strong>{moves.length} code {moves.length === 1 ? "move" : "moves"} found.</strong>{" "}Destinations are pinned beside their sources. Hover a change to review and collapse every linked copy.</>
        ) : (
          <><strong>No confident moves found.</strong>{" "}Hover a changed block to mark it reviewed and collapse it.</>
        )}
      </div>
    </>
  );
}
